import {
    SET_COMPETITION_POOMSAE,
    SET_NIVEAUX_COMPETITION_POOMSAE,
    SET_LISTE_COMPETITION_POOMSAE,
    SET_CATEG_AGE_POOMSAE,
    SET_CATEG_GRADE_POOMSAE,
    // SET_CATEG_POIDS_POOMSAE,
} from './mutations-type'

var _ = require('underscore');

// initial state
const state = {
    competition_poomsae: null,
    textes: null,
    niveaux_competition_poomsae: [],
    liste_competition_poomsae: [],
    categ_age_poomsae: [],
    categ_grade_poomsae: [],
    // categ_poids_poomsae: [],
}

// mutations
const mutations = {
    [SET_COMPETITION_POOMSAE](state, message) {
        state.competition_poomsae = message;
    },
    [SET_NIVEAUX_COMPETITION_POOMSAE](state, message) {
        state.niveaux_competition_poomsae = message;
    },
    [SET_LISTE_COMPETITION_POOMSAE](state, message) {
        state.liste_competition_poomsae = message;
    },
    [SET_CATEG_AGE_POOMSAE](state, message) {
        state.categ_age_poomsae = message;
    },
    [SET_CATEG_GRADE_POOMSAE](state, message) {
        state.categ_grade_poomsae = message;
    },
    // [SET_CATEG_POIDS_POOMSAE](state, message) {
    //     state.categ_poids_poomsae = message;
    // },
}

const actions = {
    setCompetitionPoomsae({ commit }, msg) {
        commit(SET_COMPETITION_POOMSAE, msg)
    },
    setNiveauxCompetitionPoomsae({ commit }, msg) {
        commit(SET_NIVEAUX_COMPETITION_POOMSAE, msg)
    },
    setListeCompetitionPoomsae({ commit }, msg) {
        commit(SET_LISTE_COMPETITION_POOMSAE, msg)
    },
    setCategAgePoomsae({ commit }, msg) {
        commit(SET_CATEG_AGE_POOMSAE, msg)
    },
    setCategGradePoomsae({ commit }, msg) {
        commit(SET_CATEG_GRADE_POOMSAE, msg)
    },
    // setCategPoidsPoomsae({ commit }, msg) {
    //     commit(SET_CATEG_POIDS_POOMSAE, msg)
    // },
}

const getters = {
    getCompetitionPoomsae: state => {
        return state.competition_poomsae;
    },
    getNiveauxCompetitionPoomsae: state => {
        return state.niveaux_competition_poomsae;
    },
    getCategAgePoomsae: state => {
        return state.categ_age_poomsae;
    },
    getCategGradePoomsae: state => {
        return state.categ_grade_poomsae;
    },
    // getCategPoidsPoomsae: state => {
    //     return state.categ_poids_poomsae;
    // },
    getListeCompetitionPoomsae: state => {
        return state.liste_competition_poomsae;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/vuex/store-competition-poomsae.js